import styled from "styled-components"
import { TextSectionWrapperStyle } from "./text-section-styles"

export const TextSectionWrapper = styled.div`
  max-width: 996px;
  padding: 10px 40px;
  margin: auto;
  ${TextSectionWrapperStyle}
`;
